module.exports = {
    INACTIVITY_INTERVAL_MINS: 5
}
